module.exports = __webpack_public_path__ + "images/agent_heade3bde88dac349036858aea45f521590f.svg";